module.exports = __webpack_public_path__ + "static/media/stretching.0f048c3d.svg";